import { render, staticRenderFns } from "./CreateProductModal.vue?vue&type=template&id=d0977676"
import script from "./CreateProductModal.vue?vue&type=script&lang=ts"
export * from "./CreateProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports